export const HeadingSize = {
  BIG: 'Big',
  SMALL: 'Small',
} as const;

export type HeadingSizeValue = (typeof HeadingSize)[keyof typeof HeadingSize];

export interface IHeadingSize {
  id: number;
  name: HeadingSizeValue;
}
